/**
 * Cruise line / sub-brand logo URLs from public/images (copied from iOS Assets).
 * Asset names match catalog labels exactly, same as CruiseLineLogoView on iOS.
 *
 * Filenames keep spaces (e.g. "Azamara Cruises.png"). We encode path segments
 * so static hosting resolves them reliably.
 */

const LOGOS_BASE = '/images/cruise-logos';
const SUBBRANDS_BASE = '/images/cruise-subbrands';

function logoPath(base: string, name: string): string | null {
  const trimmed = name.trim();
  if (!trimmed) return null;
  // encodeURIComponent turns spaces into %20; leave the .png extension unencoded.
  return `${base}/${encodeURIComponent(trimmed)}.png`;
}

export function cruiseLineLogoUrl(cruiseLine: string): string | null {
  return logoPath(LOGOS_BASE, cruiseLine);
}

/** Asset used for the synthetic "All sub-brands" picker row (#114). */
export const ALL_SUBBRANDS_ASSET_NAME = 'all_subbrands';

export function cruiseSubBrandLogoUrl(
  label: string,
  options?: { allSubBrandsLabel?: string }
): string | null {
  const trimmed = label.trim();
  if (!trimmed) return null;

  const allLabel = (options?.allSubBrandsLabel ?? 'All sub-brands').trim();
  if (trimmed === allLabel || trimmed.toLowerCase() === 'all sub-brands') {
    return logoPath(SUBBRANDS_BASE, ALL_SUBBRANDS_ASSET_NAME);
  }

  return logoPath(SUBBRANDS_BASE, trimmed);
}
